export default {
  error: {
    title: 'Erreur',
    retryButton: 'Réessayer',
  },
};
